export const timelineAnalysisMock = {
    factors: [
        {
            key: 'predominantSentiment',
            value: '😀 Satisfeito',
            count: 5,
            percentage: 60,
            evidence: [
                { id: '1', label: '16/08', satisfaction: '😀' },
                { id: '3', label: '01/08', satisfaction: '😀' },
                { id: '4', label: '15/08', satisfaction: '😀' },
            ],
        },
        {
            key: 'estimatedSatisfaction',
            value: '59/100',
            count: 2,
            evidence: [
                { id: '2', label: '23/08', satisfaction: '😐' },
                { id: '4', label: '15/08', satisfaction: '😀' },
            ],
        },
        {
            key: 'trend',
            value: 'Estável',
            trend: 'stable',
            evidence: [
                { id: '1', label: '16/08', satisfaction: '😀' },
                { id: '2', label: '23/08', satisfaction: '😐' },
            ],
        },
    ],
    analysis:
        'A relação com a Fintrust Capital vinha estável sob tratativas de integração e renovação contratual, mas sofreu uma queda recente de satisfação que reduziu o health score para 59. O principal ponto de atrito foi uma indisponibilidade de 40 minutos no sistema em horário de pico, o que gerou forte insatisfação e a exigência de reembolso e de um relatório de causa raiz. Como próxima ação recomendada, deve-se formalizar o envio do relatório técnico de causa raiz e conceder o crédito na fatura solicitado para restabelecer a confiança do cliente antes da renovação de fim de ano.',
};
